import { useSelector } from 'react-redux'
import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from './store'
import { useDispatchActions, setStoreState } from './utils'
import { storageUtil } from '@/utils'
import { IUserInfo } from '@/types/common'


const initialState: IUserInfo = {
  uid: 0,
  nikeName: '',
  duid: '',
  rid: 0,
  nickname: '',
  avatar: '',
  country: '',
  charmLv: 0,
  wealthLv: 0,
  gender: 0
}

export const slice = createSlice({
  name: 'userInfo',
  initialState,
  reducers: {
    setUserInfo: (state, action: PayloadAction<IUserInfo>) => {
      const cacheUserInfo = storageUtil.getSessionStorage('userInfo', true) || {}
      const payload = {
        ...action.payload
      }

      if (action.payload.cacheUserRole as number >= 0) {
        payload.cacheUserRole = action.payload.cacheUserRole
      } else if (cacheUserInfo.cacheUserRole >= 0 && cacheUserInfo.uid === action.payload.uid) {
        payload.cacheUserRole = cacheUserInfo.cacheUserRole
      } else {
        payload.cacheUserRole = action.payload.agent === 1 ? 0 : 1 // 0 代理商 1 主播
      }

      setStoreState(state, payload)
      storageUtil.setSessionStorage('userInfo', JSON.stringify(payload))
    },
    // 清除 userInfo 的方法
    clearUserInfo: (state) => {
      setStoreState(state, initialState)
      storageUtil.removeSessionStorage('userInfo')
    }
  },
})

export const { setUserInfo: userInfoActionCreator } = slice.actions
export const reducer = slice.reducer

export default function useCorpInfoStore() {
  const state = useSelector((state: RootState) => state.userInfo)
  const storageState = storageUtil.getSessionStorage('userInfo', true) || {}
  const actionPool = useDispatchActions(slice.actions)
  const totalState = { ...state, ...storageState }

  return {
    userInfo: totalState,
    ...actionPool,
  }
}
